var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6h2V4h4V2h-4V0h-2zM0 2h12v2H0zm14 18h2v-2h4v-2h-4v-2h-2zM0 18v-2h12v2zm6-5.04v-6H4v2H0v2h4v2zm2-2v-2h12v2z"
  })));
};
export default SvgFilters;